import { Box, Flex, Text, Skeleton, Button } from "@chakra-ui/react";
import MensagemBox from "./MensagemBox";
import { useDashboardMensagem } from "features/dashboards/hooks/useDashboardMensagem";
import { useDashboardPrincipal } from "features/dashboards/store";
import moment from "moment";
import { Empty } from "antd";
import { useHistory } from "react-router-dom";

function CardMensagens() {
  const history = useHistory();
  const { query } = useDashboardPrincipal();
  const { data, isFetching } = useDashboardMensagem(query);

  return (
    <Box
      boxShadow="0 0 24px rgba(0,0,0,.05)"
      bg="white"
      rounded="16px"
      p="24px"
      mt="16px"
      d="flex"
      flexDir="column"
    >
      <Flex mb={4}>
        <Text fontSize="20px">
          {data?.total === 1
            ? `${data?.total} mensagem não lida`
            : `${data?.total ?? 0} mensagens não lidas`}
        </Text>
      </Flex>
      <Flex flexDir="column" flex={1}>
        {isFetching ? (
          <Box>
            <Skeleton mb="16px" w="100%" h="145px" />
            <Skeleton mb="16px" w="100%" h="145px" />
            <Skeleton w="100%" h="145px" />
          </Box>
        ) : null}

        {!isFetching
          ? data?.items.map((message, index) => (
              <MensagemBox
                id={message.id}
                name={message.pessoa.nome}
                date={moment(message.data).format("DD/MM/YYYY")}
                time={moment(message.data).format("HH:mm")}
                message={message.descricao}
                isLast={data.items.length - 1 === index}
                novasRespostas={message.novasRespostas}
              />
            ))
          : null}

        {!isFetching && !data?.items.length ? (
          <Flex justifyContent="center" alignItems="center" flex={1}>
            <Empty />
          </Flex>
        ) : null}

        {data?.total! > 3 ? (
          <Button
            isFullWidth
            onClick={() => history.push("/administracao/mensagens")}
          >
            Ver mais
          </Button>
        ) : null}
      </Flex>
    </Box>
  );
}

export default CardMensagens;
